<template>
  <div style="margin: 15px">
    <!-- <h3>区块同步情况：</h3>
    <div>最新区块高度：{{ obj.nowBlockNumber }}</div>
    <div>
      已同步高度：{{ obj.synBlockNumber }}（还差{{
        obj.nowBlockNumber - obj.synBlockNumber
      }}）
    </div>
    <div>最后同步时间：{{ obj.modifyDate }}（{{ blogRunTime }}前）</div> -->
  </div>
</template>

<script>
export default {
  name: 'DashboardAdmin',
  data() {
    return {
      obj: {},
      blogRunTime: ''
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      var params = {}
    }
  }
}
</script>

<style lang="scss" scoped></style>
